module.exports = __webpack_public_path__ + "static/media/Second-Digital-Mattress-Tag.a5d7980c.jpg";